$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
	infinite: false,
	draggable: false,
// 	  fade: true,
//    autoplay: true,
//    autoplaySpeed: 2000,
    prevArrow: '<div class="sl-btn slick-prev"><img src="https://cdn.shopify.com/s/files/1/1426/1778/files/slider-arrow.svg"></div>',
    nextArrow: '<div class="sl-btn slick-next"><img src="https://cdn.shopify.com/s/files/1/1426/1778/files/slider-arrow.svg"></div>',
    asNavFor: '.slider-nav'
});
	
$('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    arrows: false,
    dots: false,
	infinite: false,
    centerMode: false,
    focusOnSelect: true,
	touchThreshold:100,
});

$('.week-slider .slider-nav').slick('unslick');
$('.week-slider .slider-nav').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    arrows: false,
    dots: false,
	infinite: false,
    centerMode: false,
    focusOnSelect: true,
	touchThreshold:100,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        }
      }
    ]
});


$('.slider-for').on('beforeChange', function(event, slick, direction){
    $('.slider-for video').trigger('pause');
});


if(document.querySelector('body').classList.contains('template-product')){
// select the target node
var target = document.querySelector('.price-div');

function atc_func(){
  if(document.querySelector('.recharge-inner-most-price')){
    let mt_price = document.querySelector('.recharge-inner-most-price').innerText;
    let atc_price = `Add to Cart | ${mt_price}`;
    document.querySelector('.product-form__submit span').innerText = atc_price;
  }
};
  
// create an observer instance
var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        atc_func();
    });
});
  
// configuration of the observer:
var config = { attributes: true, childList: true, characterData: true }

// pass in the target node, as well as the observer options
observer.observe(target, config);

}

$('.starter-set [name="options[Fragrance Collection]"]').on('change', function() {
  $('.starter-set input[value="'+this.value+'"]').trigger('click');
});;

$('.sub-prod [name="options[Fragrance]"]').on('change', function() {
  $('.sub-prod input[value="'+this.value+'"]').trigger('click');
});;

$(document).ready(function(){
  $(document).on('change','.starter-set [name="properties[Number of Bathrooms]"]',function(){
    if($(this).val()=="The Bathroom Starter Set"){
      $('.starter-set .quantity__input').val(1);
    }
    if($(this).val()=="2 x Bathroom Starter Sets + Free Shipping"){
      $('.starter-set .quantity__input').val(2);
    }
    if($(this).val()=="3 x Bathroom Starter Sets + Free Shipping + Free Weekend Bundle"){
      $('.starter-set .quantity__input').val(3);
    }
  });
});


























